export const gradientBorder = {
  position: 'relative',
  borderImageSlice: 1,
  textTransform: 'none',
  borderRadius: '40px',
  height: '3rem',
  fontFamily: 'Schibsted Grotesk',
  fontWeight: 600,
  fontSize: '1rem',
  color: 'black',
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    borderRadius: '50px',
    padding: '.2rem',
    background: 'linear-gradient(340deg, #00CECF 16.77%, #03FF75 53.83%)',
    WebkitMask:
      'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
    WebkitMaskComposite: 'xor',
    maskComposite: 'exclude',
  },
};

export const gradientBackground = {
  position: 'relative',
  borderImageSlice: 1,
  textTransform: 'none',
  borderRadius: '40px',
  height: '3rem',
  fontFamily: 'Schibsted Grotesk',
  fontWeight: 500,
  fontSize: '1rem',
  color: 'black',
  background:
    'var(--Gradient-A-2, linear-gradient(294deg, #00CECF 16.77%, #03FF75 53.83%))',
  transition: 'background 0s',

  '&:hover': {
    background: 'var(--Green, #03FF75)',
    color: 'black',
  },

  '&:active, &:focus': {
    background: '#03E067',
    '--button-background': '#03E067',
    color: 'black',
  },
};

export const variantTextButton = {
  textTransform: 'none',
  borderRadius: '40px',
  height: '3.1rem',
  fontSize: '1rem',
  color: 'black',
  // border: '1px solid black',
  transition: 'background-color 0.3s ease-in-out',
};
